import React from 'react';

export function GlobalStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@400;500;600&display=swap');

      :root {
        /* Backgrounds */
        --bg-primary: #0a0c10;
        --bg-elevated: #12151a;
        --bg-subtle: #1a1d24;

        /* Text */
        --text-primary: #f0f0f0;
        --text-secondary: #a0a0a0;
        --text-tertiary: #606060;
        --text-disabled: #404040;

        /* Borders */
        --border-subtle: rgba(255, 255, 255, 0.04);
        --border-default: rgba(255, 255, 255, 0.06);
        --border-strong: rgba(255, 255, 255, 0.10);

        /* Accent - use sparingly */
        --accent: #00ff88;
        --accent-muted: rgba(0, 255, 136, 0.15);

        /* Semantic */
        --negative: #ff6b6b;
        --negative-muted: rgba(255, 107, 107, 0.15);

        /* Typography */
        --font-sans: "IBM Plex Sans", -apple-system, sans-serif;
        --font-mono: "IBM Plex Mono", monospace;
      }

      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }

      body {
        font-family: var(--font-sans);
        background: var(--bg-primary);
        color: var(--text-primary);
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      ::-webkit-scrollbar-track {
        background: var(--bg-subtle);
      }

      ::-webkit-scrollbar-thumb {
        background: var(--text-disabled);
        border-radius: 3px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: var(--text-tertiary);
      }

      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.4; }
      }

      @keyframes subtle-glow {
        0%, 100% { box-shadow: 0 0 4px var(--accent); }
        50% { box-shadow: 0 0 8px var(--accent); }
      }
    `}</style>
  );
}
